export const initialFilterState = () => {
  return {
    startDate: null,
    endDate: null,
    searchKey: "",
    order: "desc",
    searchType: "stationCode",
    orderBy: "",
    page: 1,
    perPage: 10,
  };
};
